module.exports = __webpack_public_path__ + "img/pic1.312881e1.png";